/* DA Framboise — petits comportements : défilement doux du hero. */
document.addEventListener('click', function (event) {
  var link = event.target.closest('.gs-hero__scroll');
  if (!link) return;
  var target = document.querySelector(link.getAttribute('href'));
  if (!target) return;
  event.preventDefault();
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
});
